import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
    ContractGroupTypeActionTypes,
    GetContractGroupTypeResponse,
} from '../../actions/mdqx/contract-group-type.actions';
import { BaseActionTypes } from '../../actions/base.actions';
import { ContractGroupTypeEntity } from '../../../entities/mdqx/contract-group-type.entity';
import { HttpService } from '../../../services/http.service';
import { DaveActions } from '../../actions/actions';
import { State } from '../../index';
import { getToken } from '../../selectors/base.selectors';
import { environment } from '../../../../../environments/environment';

enum ErrorCodes {
    Get = 'ContractGroupType Abrufen fehlgeschlagen',
}

@Injectable()
export class ContractGroupTypeEffects {
    
    get$ = createEffect(() => this.actions$.pipe(
        ofType(ContractGroupTypeActionTypes.GetContractGroupTypeRequest),
        map(
            () => `
            {
                contractGroupType {
                    ${ContractGroupTypeEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                map(res => res && res.contractGroupType),
                concatMap(res =>
                    res
                        ? [
                              new GetContractGroupTypeResponse(
                                  res.map(
                                      contractGroupType =>
                                          new ContractGroupTypeEntity(contractGroupType),
                                  ),
                              ),
                          ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
                ),
        ),
    ));

    constructor(
        private actions$: Actions<DaveActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {}
}
